import { G_initials } from "../../../../utils/globals/initials";
import { ENV_DEV } from "../../../../utils/window";
import optimizeInitialParent from "./optimize-initial-parent";

/**
 * Process the values form computedStyle
 * @param {PropertyWrapperProps} data
 * @param {String} parameters
 * @returns {Map<"name" | "parameters", string>}
 */
const getInitialStyle = (data, parameters) => {
  /** Computed initial value string */
  let string = "";

  /** Parent name */
  const name = data.get("name") || "";

  /** Parent values */
  const values = data.get("parameters") || "";

  if (parameters === "none") {
    let value = "";
    const fnParent = ["transform", "filter", "backdrop-filter"].includes(name);

    if (fnParent) {
      const fn = values.slice(0, values.indexOf("("));
      value = /** @type {String} */ (G_initials.get(name)?.get(fn));
      string = `${fn}(${value})`;
    } else {
      string = /** @type {String} */ (G_initials.get("other")?.get(name));
    }

    if (ENV_DEV && !string) {
      console.warn(`[TorusKit warn]: No default values for \`${name}\` found.`);
    }
  } else {
    if (name === "background") {
      string = `&${values}`;
    } else {
      string = parameters;
    }
  }

  return optimizeInitialParent(name, string);
};

export default getInitialStyle;
